<template>
  <boxed-tab
    :selected-idx="activeSortIdx"
    @update:selected-idx="onSorterChange"
  >
    <div v-for="(item, idx) in SORTER_ENUM" :key="idx">
      {{ item.text }}
    </div>
  </boxed-tab>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const props = defineProps<{
  sort: "desc" | "asc";
}>();

const { t } = useI18n();

const activeSortIdx = computed(() => {
  return props.sort === "desc" ? 0 : 1;
});

const emit = defineEmits<{
  (e: "update:sort", sort: "desc" | "asc"): void;
}>();

const onSorterChange = (idx: number) => {
  emit("update:sort", SORTER_ENUM[idx].value === 0 ? "desc" : "asc");
};

const SORTER_ENUM = [
  {
    text: t(`module.timeline.timeDesc`),
    value: 0,
  },
  {
    text: t(`module.timeline.timeAsc`),
    value: 1,
  },
];
</script>
